<div id="receipt-print-area">
    <div class="modal-header">
        <h4 class="modal-title order-type" (click)="copyWhatsApp()">
            #{{ order.orderMasterId }} <span> - {{ order.orderType === 'delivery' ? 'Delivery' : 'Reservation' }}</span>
        </h4>
        <button type="button" class="close" (click)="activeModal.close()">
            <span>×</span>
        </button>
    </div>
    <div class="modal-body p-0">
        <div class="order-states">
            <div class="order-stat">
                <div class="top">{{ order.placedAt | date: 'hh:mm a':'+0200' }}</div>
                <div class="bottom">Order Received</div>
            </div>
            <div class="order-stat" [hidden]="order.status === 'Placed' || order.status === 'Canceled'">
                <div class="top">{{ order.acceptedAt | date: 'hh:mm a':'+0200' }}</div>
                <div class="bottom">Order Accepted</div>
            </div>
            <div class="order-stat" [hidden]="order.status === 'Placed' || order.status === 'Accepted' || order.status === 'Canceled'">
                <div class="top">{{ order.inDeliveryAt | date: 'hh:mm a':'+0200' }}</div>
                <div class="bottom">Order In Delivery</div>
            </div>
            <div
                class="order-stat"
                [hidden]="order.status === 'Placed' || order.status === 'Accepted' || order.status === 'In Delivery' || order.status === 'Canceled'"
            >
                <div class="top">{{ order.deliveredAt | date: 'hh:mm a':'+0200' }}</div>
                <div class="bottom">Order Delivered</div>
            </div>
            <div
                class="order-stat canceled-order"
                [hidden]="order.status === 'Placed' || order.status === 'Accepted' || order.status === 'In Delivery' || order.status === 'Delivered'"
            >
                <div class="top">{{ order.canceledAt | date: 'hh:mm a':'+0200' }}</div>
                <div class="bottom">Order Canceled</div>
            </div>
        </div>
        <div class="order-header">
            <div class="top">
                <div>
                    <span>{{ order.branchName }}</span>
                </div>
                <div>
                    <span>({{ order.locationName }})</span>
                </div>
            </div>
            <div class="bottom">
                <div>
                    Order Received <span>{{ order.placedAt | date: 'MM/dd/yyyy, hh:mm a' }}</span>
                </div>
                <div>
                    Order Type <span>{{ order.orderType === 'delivery' ? 'Delivery' : 'Reservation' }}</span>
                </div>
                <div *ngIf="order.orderType === 'reservation'">
                    Reservation Date <span>{{ order.reservationDate | date: 'MM/dd/yyyy' }}</span>
                </div>
                <div *ngIf="order.orderType === 'reservation'">
                    Reservation Time <span>{{ order.reservationTime }}</span>
                </div>
                <div>
                    Payment Type <span>{{ order.paymentType === 'cash' ? 'Cash' : 'Credit' }}</span>
                </div>
            </div>
        </div>

        <div class="order-customer">
            <div class="label">Customer</div>
            <div class="name">
                <span>{{ order.userAddress.firstName }} {{ order.userAddress.lastName }}</span>
            </div>
            <div class="address">
                <span>{{ order.userAddress.address }} {{ order.userAddress.remark ? ' ,' + order.userAddress.remark : '' }}</span>
            </div>
            <div class="phone">
                <span>{{ order.userAddress.phone }} {{ order.userAddress.alternatePhone ? ' - ' + order.userAddress.alternatePhone : '' }}</span>
            </div>
        </div>
        <div class="order-details">
            <div class="label">Order Details</div>
            <div class="order-details-list">
                <div class="order-details-list-item" *ngFor="let item of order.orderDetailViewModel">
                    <div class="left">
                        <div class="mr-4 font-weight-bold">{{ item.qty }}</div>
                        <div>{{ item.productName }}</div>
                    </div>
                    <div class="right font-weight-bold">{{ item.total | number: '1.2-2' }}</div>
                </div>
            </div>
        </div>
        <div class="order-footer">
            <div class="order-footer-line">
                <div class="left">SubTotal</div>
                <div class="right font-weight-bold">{{ order.subTotal | number: '1.2-2' }}</div>
            </div>
            <div class="order-footer-line">
                <div class="left">Delivery</div>
                <div class="right font-weight-bold">{{ order.delivery | number: '1.2-2' }}</div>
            </div>
            <div class="order-footer-line">
                <div class="left">
                    Discount
                    <!--<ng-container *ngIf="order.discount"> ({{ order.discount }}%) </ng-container>-->
                </div>
                <div class="right font-weight-bold">
                    {{ getDisacountValue() | number: '1.2-2' }}
                </div>
            </div>
            <div class="order-footer-line">
                <div class="left">Total</div>
                <div class="right font-weight-bold">{{ order.total | number: '1.2-2' }}</div>
            </div>
        </div>
        <div class="order-note">
            <div class="inner">Note: {{ order.deliveryNote ? order.deliveryNote : 'Customer Addtional Note' }}</div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" (click)="printReceipt()">Print Receipt</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="activeModal.close()">Close</button>
    </div>
</div>

<div id="whatsappOrderCopy">
    *طلب شراء* {{ order.orderMasterId }}#
    <br />

    <br />
    *استلام الطلب* {{ (order.placedAt | date: 'hh:mm a':'+0200').replace('PM', 'م').replace('AM', 'ص') }}
    <br />
    ________________________________
    <br />
    *الفرع* {{ order.branchName + ' (' + order.locationName + ')' }}
    <br />

    <br />
    *نوع الطلب* {{ order.orderType === 'delivery' ? 'توصيل' : 'حجز' }}
    <br />

    <br />
    *طريقة الدفع* {{ order.paymentType === 'cash' ? 'كاش' : 'كريديت' }}
    <br />
    ________________________________
    <br />
    *العميل* {{ order.userAddress.firstName }} {{ order.userAddress.lastName }}
    <br />

    <br />
    *العنوان* {{ order.userAddress.address }} {{ order.userAddress.remark ? ' ,' + order.userAddress.remark : '' }}
    <br />

    <br />
    *التليفون* {{ order.userAddress.phone }} {{ order.userAddress.alternatePhone ? ' - ' + order.userAddress.alternatePhone : '' }}
    <br />
    ________________________________

    <ng-container *ngFor="let item of order.orderDetailViewModel">
        <br />
        {{ item.qty }}&nbsp;&nbsp; {{ item.productName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ item.total | number: '1.2-2' }}
        <br />
    </ng-container>

    ________________________________
    <br />
    *الاجمالي*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ order.subTotal | number: '1.2-2' }}
    <br />

    <br />
    *التوصيل*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ order.delivery | number: '1.2-2' }}
    <br />

    <br />
    *الخصم*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ getDisacountValue() | number: '1.2-2' }}

    <br />

    <br />
    *اجمالي*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ order.total | number: '1.2-2' }}
    <br />
    ________________________________
    <br />
    *ملاحظات* {{ order.deliveryNote ? order.deliveryNote : 'لا يوجد ملاحظات' }}
    <br />

    <br />
    ```برجاء قبول الطلب```
</div>
